const $progressBar = $('.page-loading .progress-bar');

listenImagesLoading(
  $('img'),
  mainFunc,
  function(per, instance) {
    $progressBar.css({ width: per + '%' });
  }
);

/*==================================================*\
        Main Function
\*==================================================*/
// const PAGE_HEADER_ACTIVE = 'menuOpen';
let $header;
// let $hamburger;
let $headerNav;
let mobileGa;
const $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');

const indexAni = new TimelineMax({ paused: true});
    indexAni
    .from('.slogan', 0.6, { opacity: 0,scale:0.9, ease: Power0.None }, '+=0.3')
    .from('.spBox1', 0.5, { opacity: 0,y:10, ease: Power0.None }, '+=0.2')
    .from('.spBox2', 0.5, { opacity: 0,y:10, ease: Power0.None }, '-=0.5')

function mainFunc() {
  $header = $('.page-header');
  // $hamburger = $('.hamburger');
  $headerNav = $('.header-nav ul');

  /* window 事件: Resize & scroll */
  windowEvents();

  $("._lb").each(function (i, v) {
    $(v).lightbox({
        filesDefaultExtension: '.' + ($(v).data('lbext') || 'html'),
        callback: function () {
            typeof (lbOnload) != "undefined" && lbOnload();
        }
    });
  });

  /***** Header *****/
  // Hamburger
  // $hamburger.on('click', function(evt) {
  //   evt.preventDefault();
  //   evt.stopPropagation();
  //   $header.toggleClass(PAGE_HEADER_ACTIVE);

  //   if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
  //     $headerNav.stop().slideDown(DURATION.STD);
  //   } else {
  //     $headerNav.stop().slideUp(DURATION.STD);
  //   }
  // });

  // $doc.on('click', () => {
  //   if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
  //     $headerNav.stop().slideUp(DURATION.STD);
  //     $header.removeClass(PAGE_HEADER_ACTIVE);
  //   }
  // });

  // Navigation
  $('.header-nav a').on('click', function(evt) {
    evt.preventDefault();
    
    const linkIdx = $(this).parent().index();
    $('html, body').stop().animate({
      scrollTop: sectionPos[linkIdx]
    }, DURATION.NOR);
  });

  $('.header-gotop').on('click', function(evt) {
    $('html, body').stop().animate({
      scrollTop: $('.kv').offset().top
    }, DURATION.NOR);
  });

  /* 收掉 .page-loading */
  transitionThenRemove({
    dom: $(".page-loading"),
    duration: DURATION.STD,
    callback: () => {
      console.log("%cBuild Completed!", logSafeStyle);
      indexAni.play();
    }
  });
}

$(function () {

  $('._scrollto').on('click', function () {
    var someWhere = $(this).data("scrollto");
    scrollto(someWhere);
  })

  // $('.spBox1').click(function(){
  //   setTimeout(function(){ 
  //     $('.btnTutorial').trigger('click');
  //    }, 650);
  // })

});

/*==================================================*\
        window Events
\*==================================================*/
let isFirstTime = true;
let sectionPos;
let sectionPage;
let footerPos;
// let headerTopH;
// let headerNavH;
// let headerTotalH;
function windowEvents() {
  // Window Resize
  $win.on("resize", _resize).resize();
  // Window Scroll
  $win.on("scroll", _scroll).scroll();
}

/*========== Window Resize ==========*/
function _resize() {
  getSize();
  getSectionPos();
  // winW > 768 ? resizePC() : resizeMB();

  footerPos = $('footer').offset().top;
  
  // if(device.desktop() && winW > 768){
  //   resizePC();
  //   mobileGa = "";
  // }

  // if(winW <= 768 || device.mobile() || device.tablet()){
  //     resizeMB();
  //     mobileGa = "m_";
  // }
}

function getSize() {
  winW = $win.width();
  winH = $win.height();
  // headerTopH = 0;
  // headerNavH = $('.header-nav').outerHeight();
}

function resizePC() {
  // headerInit('flex');
  // $('.main-container').css({ marginTop: headerTopH + headerNavH });
  // headerTotalH = headerTopH + headerNavH;
}
function resizeMB() {
  // headerInit('none');
  // $('.main-container').css({ marginTop: headerTopH });
  // headerTotalH = headerTopH;
}

// function headerInit(display) {
//   $header.removeClass(PAGE_HEADER_ACTIVE);
//   $headerNav.css({ display });
// }

function getSectionPos() {
  sectionPos = [];
  sectionPage = [];

  $.each($('main .anchor'), (idx, el) => {
    sectionPos.push(Math.floor($(el).offset().top));
    sectionPage.push($(el).attr('data-page'));
  });
}


/*========== Window Scroll ==========*/
let nowPos;
function _scroll() {
  getPos();
  setNavigationHint();

  var winTop = $(window).scrollTop();
    if(winTop == 0){
      gtag('event', 'pageName', {
        'event_label': 'index'
      });
    }
    if (winTop >= 250) {
        $header.css('opacity', '1');
    } else {
        $header.css('opacity', '0');
    }
}

function getPos() {
  nowPos = {
    x: $doc.scrollLeft(),
    y: $doc.scrollTop(),
    top: $doc.scrollTop() + 1
  };
}

function setNavigationHint() {
  const $navLi = $('.header-nav li');
  const NAV_HINT_CLASS = 'active';

  $.each(sectionPos, (idx, val) => {
    if ((idx === 0 && nowPos.top < sectionPos[0]) || nowPos.top >= footerPos) {
      $navLi.removeClass(NAV_HINT_CLASS);
      return false;
    }

    if (nowPos.top >= sectionPos[idx] && nowPos.top <= sectionPos[idx] +25) {
      
      if(device.desktop() && winW > 768){
        gtag('event', 'pageName', {
          'event_label': sectionPage[idx]
        });
      }

      if(winW <= 768 || device.mobile() || device.tablet()){
        gtag('event', 'pageName', {
          'event_label': 'm_' + sectionPage[idx]
        });
      }
    }

    if (nowPos.top >= val) {
      $navLi.removeClass(NAV_HINT_CLASS);
      $navLi.eq(idx).addClass(NAV_HINT_CLASS);
      if(winW <= 768){
        var posNav = $navLi.eq(idx).offset().left - $('.header-nav').offset().left + $('.header-nav').scrollLeft() - $navLi.eq(idx).width();
        $('.header-nav').scrollLeft(posNav);
      }
    }

  });
}

function scrollto(anchor) {
  $body.stop().animate({
      scrollTop: $('#' + anchor).offset().top
  }, 500);
}

function navScrollLeft() {

  var posNav = $('.header-nav .active').offset().left - ($(window).width() *0.15);
  $('.header-nav').scrollLeft(posNav);
  
}